/**
 * Flickity file to put all the site sliders in.
 */

import imagesLoaded from 'imagesloaded';
import 'flickity/css/flickity.css';
import Flickity from 'flickity';

jQuery( $ => {
	/**
	 * Flickity that is shown on all archive/shop/tax-pages
	 * Slider content can be found in archive-popular-products.php
	 */
	const archiveCarousel = $( '.popular-products-slider > ul.products' );
	if ( 0 < archiveCarousel.length ) {
		new imagesLoaded( $( '.popular-products-slider' ), { background: true }, function() {
			const options = {
				contain: true,
				wrapAround: true,
				pageDots: false,
				groupCells: '100%',
				freeScroll: false,
				draggable: true,
				cellAlign: 'center',
			};

			$.each( $( '.popular-products-slider > ul.products' ), ( key, value ) => {
				new Flickity( value, options );
			} );
		} );
	}

	/**
	 * Generic products slider.
	 * Used on for example cross sells on single product.
	 */
	const productsCarousel = $( '.products-slider > ul.products' );
	if ( 0 < productsCarousel.length ) {
		new imagesLoaded( $( '.products-slider' ), { background: true }, function() {
			const options = {
				contain: true,
				wrapAround: false,
				pageDots: false,
				groupCells: '100%',
				freeScroll: false,
				draggable: true,
				cellAlign: 'center',
			};

			$.each( $( '.products-slider > ul.products' ), ( key, value ) => {
				new Flickity( value, options );
			} );
		} );
	}

	/**
	 * Grid slider
	 * Will turn a regular grid into a slider at specified breakpoint.
	 */
	const gridCarousel = $( '[class*=grid-slider]' );
	if ( 0 < gridCarousel.length ) {
		new imagesLoaded( $( '[class*=grid-slider]' ), { background: true }, () => {
			let options = {
				contain: true,
				wrapAround: false,
				pageDots: false,
				prevNextButtons: false,
				groupCells: '100%',
				freeScroll: false,
				draggable: true,
				cellAlign: 'left',
				watchCSS: true,
				dragThreshold: 10,
			};

			$.each( gridCarousel, ( key, value ) => {
				const customControls = value.dataset;
				if ( customControls ) {
					options = { ...options, ...customControls };
				}
				new Flickity( value, options );
			} );
		} );
	}

	/**
	 * Slider for news module
	 */
	const newsCarousel = $( '.post-cards' );
	if ( 0 < newsCarousel.length ) {
		new imagesLoaded( $( '.post-cards' ), { background: true }, () => {
			const options = {
				contain: true,
				wrapAround: true,
				pageDots: true,
				groupCells: '100%',
				freeScroll: false,
				draggable: true,
				cellAlign: 'left',
			};

			if ( 768 < $( window ).width() ) {
				options.cellAlign = 'center';
			}

			$.each( newsCarousel, ( key, value ) => {
				new Flickity( value, options );
			} );
		} );
	}
} );
